import $ from "jquery";

function resizeWindow() {
    let width = document.documentElement.clientWidth;
    let height = document.documentElement.clientHeight;

    if (width < 991) {
        $('.blog-menu.main-menu--blog').appendTo($('.blog-menu--mobile'));
    } else {
        $('.blog-menu.main-menu--blog').appendTo($('.header-link'));
    }
    return {width, height};
}

export default {
    init() {
        resizeWindow();
        window.addEventListener('resize', resizeWindow);
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS

        $(document).mouseup(function (e) {
            if ($('.blog-menu').css('display') !== 'none' && document.documentElement.clientWidth < 992) {
                let div = $(".blog-menu__content");
                if (!div.is(e.target)
                    && div.has(e.target).length === 0) {
                    div.parent().fadeOut();
                }
            }
        });

        $('.main-menu__blog-mobile').on('click', () => {
            $('.blog-menu').fadeIn();
        });

        $('.blog-menu__close').on('click', () => {
            $('.blog-menu').fadeOut();
        });

        $('a.blog__subscription').on('click', (function (e) {
            e.preventDefault();
            let first_input = $('form').find('*').filter(':input:visible:first');
            $('html, body').animate({scrollTop: $(first_input).offset().top - 200}, 500);
            first_input.focus();
        }));
    },
};
